var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlightViewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.15232 10.6682L5.03519 11.5031C4.99706 11.5323 4.96529 11.5946 4.96529 11.6442V13.0701C4.96529 13.1184 4.99833 13.1375 5.04027 13.112L6.84751 12.244C6.90724 12.2123 6.94028 12.2021 7.01781 12.244L8.94578 13.1578C8.98645 13.1819 9.02076 13.1641 9.02076 13.1158V11.6899C9.02076 11.6416 8.98899 11.5794 8.94959 11.5489L7.7956 10.6872C7.78798 10.6809 7.78035 10.6783 7.774 10.6758V10.6682L7.89346 7.39694L13.3762 9.1177C13.4219 9.13295 13.46 9.10499 13.46 9.05669V7.75024C13.46 7.70195 13.4257 7.64222 13.3851 7.6168L8.0053 4.33669L8.10444 1.6094C8.10444 0.79859 7.59988 0.142822 6.97841 0.142822C6.35694 0.142822 5.85239 0.799861 5.85239 1.6094L5.94262 4.34304L0.57303 7.61553C0.53109 7.63968 0.498047 7.70068 0.498047 7.74897V9.05542C0.498047 9.10372 0.534903 9.13041 0.581927 9.11643L6.04429 7.4033L6.15232 10.6682Z",
    fill: "#0C002C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66211 15.5522C1.66211 15.2259 1.92657 14.9615 2.25279 14.9615H11.7037C12.03 14.9615 12.2944 15.2259 12.2944 15.5522C12.2944 15.8784 12.03 16.1428 11.7037 16.1428H2.25279C1.92657 16.1428 1.66211 15.8784 1.66211 15.5522Z",
    fill: "#0C002C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightViewIcon);
export default __webpack_public_path__ + "static/media/flightViewIcon.30ebf010775ced06a3efbe480e1a0e6f.svg";
export { ForwardRef as ReactComponent };